<template>
  <div>
    <!--S 右侧区域-->
    <!-- <transition name="slide-right"> -->
    <router-view></router-view>
    <!-- </transition> -->
    <!--E 右侧区域-->
  </div>
</template>
<script>
export default {
  name: "Order_BangKa",
  data() {
    return {
    };
  },
  filters: {},
  components: {},
  methods: {},
  created() {},
  watch: {},
  mounted() {},
  computed: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/OrderBangKa/Order_BangKa.vue